import React, { FC, useState } from "react";
import { Stack, Typography, ListItem, Skeleton } from "@mui/material";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import { useGetInstanceQuery, useGetDomainsQuery } from "../../../../services/accounts";
import { DropdownMenu } from "./DropdownMenu";
import { InstanceAvatar } from "../InstanceAvatar";
interface InstanceMenuProps {
  openNav: boolean;
}
export const InstanceMenu: FC<InstanceMenuProps> = ({
  openNav
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const {
    data: instance,
    isLoading: isLoadingInstance
  } = useGetInstanceQuery();
  const {
    data
  } = useGetDomainsQuery();
  return <>
      <ListItem sx={{
      px: 0.5,
      py: 0,
      mb: 0.75,
      height: 48
    }} data-sentry-element="ListItem" data-sentry-source-file="index.tsx">
        <Stack data-cy="InstanceMenuButton" direction="row" width="100%" justifyContent="space-between" alignItems="center" gap={1} color="grey.500" sx={{
        px: 0.5,
        py: 0.75,
        borderRadius: "4px",
        minWidth: "40px",
        "&:hover": {
          color: "primary.main",
          cursor: "pointer",
          backgroundColor: "grey.800"
        }
      }} onClick={(evt: React.MouseEvent<HTMLDivElement>) => setAnchorEl(evt.currentTarget)} data-sentry-element="Stack" data-sentry-source-file="index.tsx">
          <Stack direction="row" gap={1} alignItems="center" data-sentry-element="Stack" data-sentry-source-file="index.tsx">
            <InstanceAvatar canUpdateAvatar={false} data-sentry-element="InstanceAvatar" data-sentry-source-file="index.tsx" />
            {openNav && <Typography variant="body3" fontWeight={600} color="common.white" display="-webkit-box" sx={{
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: "2",
            wordBreak: "break-word"
          }} overflow="hidden">
                {isLoadingInstance ? <Stack direction="row" gap={1.75}>
                    <Skeleton variant="rounded" width={112} height={12} sx={{
                bgcolor: "grey.700"
              }} />
                    <Skeleton variant="rounded" width={12} height={12} sx={{
                bgcolor: "grey.700"
              }} />
                  </Stack> : instance?.name}
              </Typography>}
          </Stack>
          {openNav && !isLoadingInstance && <ArrowDropDownRoundedIcon color="inherit" />}
        </Stack>
      </ListItem>
      {Boolean(anchorEl) && <DropdownMenu anchorEl={anchorEl} onClose={() => setAnchorEl(null)} />}
    </>;
};